<template>
  <div class="item-con">
    <div class="img-con">
      <img class="item-img" :src="item.ext_info.picture_url" alt="壹心理-消费记录">
    </div>
    <div class="item-content">
      <div>
        <p class="title">{{ item.ext_info.gift_name }}x{{ item.ext_info.gift_num }}</p>
        <p class="subheading">赠送给：{{ item.to_user.nickname }}</p>
        <p class="time">{{item.created}}</p>
      </div>
      <div class="num">{{ item.total_coin }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "consumptionItem",
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    }
  }
</script>

<style lang="scss" scoped>
.item-con {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 30px;
  background: #fff;
  margin-bottom: 30px;
  border-radius: 20px;
  .img-con {
    margin-right: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 96px;
    border-radius: 50%;
    background: #F8F9F9;

    .item-img {
      width: 96px;
      height: 96px;
    }
  }

  .item-content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    margin-bottom: 12px;
    font-family: PingFangSC-Medium;
    font-size: 32px;
    color: #21252D;
  }

  .subheading {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    margin-bottom: 12px;
    color: #7C8790;
  }

  .time {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #7C8790;
  }

  .num {
    font-family: PingFangSC-Medium;
    font-size: 32px;
    color: #21252D;
    text-align: right;
  }
}
</style>
